import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    contacts:[],
    loading:false,
    error:'',
    status:'idle',
    addContact:{}
};

export const fetchContacts = createAsyncThunk('contacts/fetchContacts', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('form/getAllContact',formData);
    if (response.status == 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const addNewContact = createAsyncThunk('contacts/addNewContact', async (initialPost) => {
    let url = '';
    let accessToken = localStorage.getItem('accessToken');
    let fromData = new FormData();
    fromData.append("firstname",initialPost.firstname);
    fromData.append("lastname",initialPost.lastname);
    fromData.append("email",initialPost.email);
    fromData.append("phone",initialPost.phone);
    fromData.append("Token",accessToken);
    if(initialPost.id){
        url = 'form/updateContact';
        fromData.append("client_id",initialPost.id);
    }else{
        url = 'form/addContact';
    }
    let response = await axios.post(url,fromData);
    if (response.status == 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}

const contacts = createSlice({
    name:'contacts',
    initialState,
    reducers:{
        blankAddContact:(state)=>{
            state.addContact = {};
        }
    },
    extraReducers:(builder) => {
        builder.addCase(fetchContacts.pending, (state)=>{
            state.loading = true;
            state.status = 'loading';
        })
        builder.addCase(fetchContacts.fulfilled,(state,action)=>{
            state.loading = false;
            state.status = 'succeeded';
            state.contacts = action.payload;
            state.error = '';
        })
        builder.addCase(fetchContacts.rejected,(state,action)=>{
            state.loading = false;
            state.status = 'failed';
            state.contacts = [];
            state.error = action.error.message;
        })
        builder.addCase(addNewContact.fulfilled,(state,action)=>{
            // state.contacts.push(action.payload)
            // state.status="idle";
            state.addContact = action.payload
        })
    }
})

export const {blankAddContact} = contacts.actions;

export default contacts.reducer;

export const selectAllContacts = (state) => state.contacts.contacts;

export const selectContactById  = (state,contactId) => {
    //console.log(contactId);
    if(contactId){ 
        //console.log(state.contacts); 
        state.contacts?.contacts?.find((contact)=>contact.id = contactId);
    }else{
        return state;
    }
};